import * as React from 'react';

interface State {
    hidden: boolean;
    timestamp: number;
    supported: boolean;
}

interface Props {
}

export class PageVisibilityAPI {

    // Browsers can show Page Visibility API support under 1 of  3 ways, so we need to query
    // which support we have in this browser
    static hiddenProperty?: string;
    static visibilityChangeProperty?: string;

    static queryPageVisibilityAPI() {
        const _document = document as any;    // cast so we can check property existance
        if (typeof _document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
            PageVisibilityAPI.hiddenProperty = 'hidden';
            PageVisibilityAPI.visibilityChangeProperty = 'visibilitychange';
            return true;
        } else if (typeof _document.msHidden !== 'undefined') {
            PageVisibilityAPI.hiddenProperty = 'msHidden';
            PageVisibilityAPI.visibilityChangeProperty = 'msvisibilitychange';
            return true;
        } else if (typeof _document.webkitHidden !== 'undefined') {
            PageVisibilityAPI.hiddenProperty = 'webkitHidden';
            PageVisibilityAPI.visibilityChangeProperty = 'webkitvisibilitychange';
            return true;
        } else return false;  // no PageAvailability available and no performance throttling will be done
    }

    // return the state of the browser tab
    static isHidden() {
        return PageVisibilityAPI.hiddenProperty
            ? (document as any)[PageVisibilityAPI.hiddenProperty]
            : false;    // no Page Visibility API support in browser, so we will always return 'not hidden'
    }

    // return if Page Visibility API is supported
    static isSupported() {
        return (PageVisibilityAPI.hiddenProperty && PageVisibilityAPI.visibilityChangeProperty)
            ? true
            : PageVisibilityAPI.queryPageVisibilityAPI();
    }

    static addListener( callback: () => void ) {
        if (PageVisibilityAPI.isSupported() && PageVisibilityAPI.visibilityChangeProperty) {
  document.addEventListener(PageVisibilityAPI.visibilityChangeProperty, callback, false);
        }
    }

    static removeListener( callback: () => void ) {
        if (PageVisibilityAPI.isSupported() && PageVisibilityAPI.visibilityChangeProperty) {
            document.removeEventListener(PageVisibilityAPI.visibilityChangeProperty, callback);
        }
    }
}

export interface PageVisibilityState {
    hidden: boolean;
    supported: boolean;
}

export type PageVisibilityFunctionSignature = (state: PageVisibilityState) => null | React.ReactNode;

export default class PageVisibility extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
    };

    constructor(props: Props) {
        super(props);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.state = {
            hidden: false,
            timestamp: new Date().valueOf(),
            supported: PageVisibilityAPI.isSupported()
        };
    }

    componentDidMount() {
        PageVisibilityAPI.addListener(this.handleVisibilityChange);
    }

    componentWillUnmount() {
        PageVisibilityAPI.removeListener(this.handleVisibilityChange);
    }

    handleVisibilityChange() {
        const _hidden = PageVisibilityAPI.isHidden();

        this.setState({
            hidden: _hidden,
            timestamp: new Date().valueOf(),
            supported: true
        });
    }

    public render() {
        const { children } = this.props;
        const { hidden, supported } = this.state;
        const childIsRenderFunction = (children && typeof children === 'function');
        return childIsRenderFunction
            ? (children as PageVisibilityFunctionSignature)({
                hidden,
                supported
            })
            : hidden
                ? null
                : children;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/PageVisibility.tsx